import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpEditProjectDetails, HttpEditProjectDetailsOptions} from '../http/projects.http'
import {MUTATION_KEYS, QUERY_KEYS, queryClient} from '@/queryClient'
import {AxiosError} from 'axios'
import {ErrorResponseData} from '@/types'

interface UseEditProjectDetailsOptions {
    urlParams: {
        projectId: string
    }
    options?: UseMutationOptions<unknown, AxiosError<ErrorResponseData>, HttpEditProjectDetailsOptions['payload']>
}

export const useEditProjectDetails = ({urlParams, options}: UseEditProjectDetailsOptions) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.EDIT_PROJECT_DETAILS, urlParams.projectId],
        mutationFn: payload => httpEditProjectDetails({urlParams, payload}),
        // Early closing, suspension and any date change alter which project covers a given date, so the
        // project lookups of the medical record report flow must not keep answering with stale data.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECTS_BY_PATIENT]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
